import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logoCompleto.svg'
import _imports_1 from '@/assets/logo-completo-dark.svg'


const _withScopeId = n => (_pushScopeId("data-v-1ecc5a2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "column" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Compañía"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Productos")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://codelabenterprise.com/content/" }, "Blog")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Contáctanos")
    ])
  ])
], -1))
const _hoisted_3 = { class: "column" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Más información", -1))
const _hoisted_5 = {
  key: 0,
  class: "footer-logo",
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = {
  key: 1,
  class: "footer-logo",
  src: _imports_1,
  alt: ""
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "copyrigth" }, " © 2024 Codelabenterprise by Codelabenterprise todos los derechos reservados ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass(["title-medium", {'dark-footer': _ctx.pathIsOptimizeTool}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/terms-of-service" }, {
              default: _withCtx(() => [
                _createTextVNode(" Términos de servicio ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/privacy-policy" }, {
              default: _withCtx(() => [
                _createTextVNode(" Politica de privacidad ")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    (!_ctx.pathIsOptimizeTool)
      ? (_openBlock(), _createElementBlock("img", _hoisted_5))
      : (_openBlock(), _createElementBlock("img", _hoisted_6)),
    _hoisted_7
  ], 2)), [
    [_vShow, !_ctx.isInFrame]
  ])
}